/**
 * Whether the given email is allowed for sandbox patient portal access,
 * using suffix match against allowedSuffixes (e.g. @tbd.health).
 */
export function isSandboxAllowedPatientEmail(email, allowedSuffixes) {
  if (!allowedSuffixes?.length) {
    return false;
  }
  const normalized = typeof email === 'string' ? email.trim().toLowerCase() : '';
  if (!normalized) {
    return false;
  }
  return allowedSuffixes.some(suffix => {
    let s = (suffix || '').trim().toLowerCase();
    if (s && !s.startsWith('@')) {
      s = `@${s}`;
    }
    return Boolean(s) && normalized.endsWith(s);
  });
}
